/** Newest history rows fetched per device. Load more walks back one page at a time. */
export const DEVICE_HISTORY_PAGE_SIZE = 100;

/**
 * Command devices write rows only when commanded. Start at the epoch so idle
 * devices still show their newest events; the page size bounds each request.
 */
export const DEVICE_HISTORY_START_MS = 0;
